import { isManagement, isOperatorAdmin } from "./auth";

export const ROLE_MANAGEMENT = "management";
export const ROLE_OPERATOR_ADMIN = "operator_admin";
export const ROLE_OPERATOR = "operator";

/* `icon` names map to the SVG set in Menu.vue; `sub` is the dropdown subtitle.
   Create Booking is not a menu entry in the redesign: it is the pink
   "New booking" action on the right of the top bar (see Menu.vue). */
export const MENU_TREE = [
    { type: "link", route: "dashboard", label: "Dashboard" },
    { type: "link", route: "bookings", label: "Bookings" },
    {
        type: "group",
        id: "location",
        label: "Location",
        children: [
            {
                route: "contacts",
                label: "Contacts",
                icon: "users",
                sub: "Newsletters and monitoring alerts",
            },
            {
                route: "opening-hours",
                label: "Opening hours",
                icon: "klok",
                sub: "Weekly hours, extra opening, closures",
            },
            {
                route: "support",
                label: "Support",
                icon: "hulp",
                sub: "Help, manual and control.x-cube.nl",
            },
            {
                route: "location",
                label: "Users",
                icon: "user",
                sub: "Operators and admins per location",
                roles: [ROLE_MANAGEMENT, ROLE_OPERATOR_ADMIN],
            },
        ],
    },
    {
        type: "group",
        id: "information",
        label: "Information",
        children: [
            {
                route: "general-information",
                label: "General information",
                icon: "boek",
                sub: "For all operators",
            },
            {
                route: "site-information",
                label: "Site information",
                icon: "pin",
                sub: "Details per location",
            },
        ],
    },
    {
        type: "group",
        id: "xcube-admin",
        label: "X-Cube Admin",
        roles: [ROLE_MANAGEMENT],
        children: [
            {
                route: "applications",
                label: "Applications",
                icon: "apps",
                sub: "Apps per device type",
            },
            {
                route: "experiences",
                label: "Experiences",
                icon: "spel",
                sub: "Games, durations and player counts",
            },
            {
                route: "xcube-control",
                label: "X-Cube Control",
                icon: "power",
                sub: "Restart the host app, with X-Corp permission",
            },
            {
                route: "tools",
                label: "Tools & downloads",
                icon: "tool",
                sub: "Customer data, invoices, login links",
            },
        ],
    },
];

export const roleFromUser = (user) => {
    if (isManagement(user)) {
        return ROLE_MANAGEMENT;
    }
    if (isOperatorAdmin(user)) {
        return ROLE_OPERATOR_ADMIN;
    }
    return ROLE_OPERATOR;
};

const allowedForRole = (item, role) => !item.roles || item.roles.includes(role);

export const menuForRole = (role) => MENU_TREE.flatMap((item) => {
    if (!allowedForRole(item, role)) {
        return [];
    }
    if (item.type !== "group") {
        return [item];
    }
    const children = item.children.filter((child) => allowedForRole(child, role));
    if (children.length === 0) {
        return [];
    }
    return [{ ...item, children }];
});

export const groupContainsRoute = (group, routeName) => (
    group.children.some((child) => child.route === routeName)
);
